export default {
  会议时间: '会议时间',
  会议赞助: '会议赞助',
  会议简介: '会议简介',
  参会嘉宾: '参会嘉宾',
  会议日程: '会议日程',
  会议地点: '会议地点',
  会场信息: '会场信息',
  会场地点: '会场地点',
  会场地址: '会场地址',
  会议门票: '会议门票',
  赞助商列表: '赞助商列表',
  会议赞助申请: '会议赞助申请',
  报名参加: '报名参加',
  会议报名: '会议报名',
  立即报名: '立即报名',
  立即申请: '立即申请',
  该会议已下架: '该会议已下架',
  该会议不存在: '该会议不存在',
  以下赞助名单排名不分前后: '以下赞助名单排名不分前后',
}
